export default __webpack_public_path__ + "static/media/_attack.eb042a96.jpg";